import { useLocalStorage } from 'hooks/useLocalStorage'
import i18n from 'i18next'
import { Select } from '@mui/material'
import React from 'react'

export default function LanguageSelector() {
  const [lng, setLng] = useLocalStorage('lng', 'sv')
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
  }
  return (
    <Select
      classes={{ select: 'py-[3px]!' }}
      native
      onChange={(e: any) => {
        changeLanguage(e.target.value)
        setLng(e.target.value)
      }}
      value={lng}
    >
      <option value={'sv'}>Svenska</option>
      <option value={'en'}>English</option>
      <option value={'da'}>Dansk</option>
      <option value={'no'}>Norsk</option>
      <option value={'fi'}>Suomi</option>
    </Select>
  )
}
